

export const updateFavicon = (iconPath) => {

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
    }
    link.href = iconPath;

    // Add a unique query parameter to prevent caching
    const timestamp = new Date().getTime();
    link.href = `${iconPath}?v=${timestamp}`;
};
